import { render, staticRenderFns } from "./InsuranceProgram.vue?vue&type=template&id=a1a587b8&scoped=true"
import script from "./InsuranceProgram.vue?vue&type=script&lang=js"
export * from "./InsuranceProgram.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProgram.vue?vue&type=style&index=0&id=a1a587b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a587b8",
  null
  
)

export default component.exports